// extracted by mini-css-extract-plugin
export default {"pill":"StatusPill_pill__RpyPO"};